import { useEffect } from 'react';
import { WithGuideLink } from '@mews-commander/types';
import { ModalBodyWrapper, ModalWrapper } from '@mews-commander/ui';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { initializeGroupBilling } from '../actions/billing';
import { BillingPageLoadingWrapper } from '../components/BillingPageLoadingWrapper';
import { GroupBilling } from './GroupBilling';
import { GroupBillingHeader } from './GroupBillingHeader';

interface GroupBillingContainerProps {
    groupId: string;
}

export const GroupBillingContainer: React.FC<GroupBillingContainerProps & WithGuideLink> = ({ groupId, guideLink }) => {
    const dispatch = useCommanderThunkDispatch();
    useEffect(() => {
        void dispatch(initializeGroupBilling({ groupId, scope: groupId }));
    }, [dispatch, groupId]);

    return (
        <ModalWrapper>
            <GroupBillingHeader groupId={groupId} guideLink={guideLink} />
            <ModalBodyWrapper>
                <BillingPageLoadingWrapper scope={groupId}>
                    <GroupBilling groupId={groupId} />
                </BillingPageLoadingWrapper>
            </ModalBodyWrapper>
        </ModalWrapper>
    );
};
